<template>
    <v-container style="padding-top:70px">
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>

        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-card flat class="text-xs-center ma-3" width="100%" v-if="vetabla">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Expediente Atlas</span>
                    </v-card-title>
                    <v-card-text>
                        <br />
                        <DataTable :url="url"
                                   :columns="head"
                                   :params="displayInputs"
                                   :order="[[0, 'desc']]"
                                   :formatterActions="formatterActions"
                                   select="multiple"
                                   @input="seleccionarReportes"
                                   :dom="'Bfrtip'"
                                   :todo="false"
                                   @SeleccionTabla="SeleccionarTodo"
                                   class="tablaEspecial"
                                   @apiDT="apiDT = $event">
                        </DataTable>
                        <br />
                        <v-row justify="center">
                            <v-btn :disabled="loadingB"
                                   @click="Guardar()"
                                   color="success">
                                Enviar Expediente
                                <template v-slot:loader>
                                    <span>Loading...</span>
                                </template>
                            </v-btn>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card flat class="text-xs-center ma-3" width="100%" v-if="vetabla == false">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Observaciones</span>
                    </v-card-title>
                    <v-card-text>
                        <br />
                        <v-simple-table v-if="observaciones.length > 0">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Movimiento</th>
                                        <th>Observación</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in observaciones" :key="item.id">
                                        <td>{{ item.ceconcepto }}</td>
                                        <td>{{ item.exobs }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <br />
                        <v-row justify="center">
                            <v-btn
                                   @click="vetabla = true"
                                   color="success">
                                Regresar
                                <template v-slot:loader>
                                    <span>Loading...</span>
                                </template>
                            </v-btn>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
    import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import General from "@/services/Operacion/Operacion.service.js";
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import UtilidadesServ from '@/services/Utilidades/Utilidades.service.js';
    import Archivos from '@/services/Archivos/Archivos.service.js';
    import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
            DataTable,
        },
        data() {
            return {
                vetabla : true,
                valid: true,
                showcargando: true,
                apiDT: null,
                displayInputs: {},
                url: "Operacion/BitacoraAtlas",
                head: [
                    { name: "reporte", data: "reporte", title: "Reporte", },
                    { name: "svfhreporte", data: "svfhreporte", title: "Fecha Reporte" },
                    { name: "svnumsin", data: "svnumsin", title: "Num. Siniestro" },
                    { name: "Concepto", data: "Concepto", title: "Concepto" },
                    { name: "flotilla", data: "flotilla", title: "Flotilla" },
                    { name: "abogado", data: "abogado", title: "Abogado" },
                    { name: "svnumave", data: "svnumave", title: "Num. Carpeta", },
                    { name: "nrreporte", data: "reporte", title: "", formatter: [this, "formatearEditar"], orderable: false },
                ],
                formatterActions: [
                    //{ click: [this, "VerArchivo"] },
                    { click: [this, "VerObservacion"] },
                ],
                ver: false,
                loadingB: true,
                seleccion: [],
                observaciones: [],
            }
        },
        watch: {
            seleccion() {
                if (this.seleccion.length > 0)
                    this.loadingB = false;
                else
                    this.loadingB = true;
            }
        },
        methods: {
            async VerObservacion(params, item, fila) {
                this.observaciones = [];
                this.vetabla = false;
                let formdata = new FormData();
                formdata.append("nrreporte", item.nrreporte);
                formdata.append("svindice", item.svindice);
                await UtilidadesServ.ObservacionesExpediente(formdata).then(data => {
                    this.observaciones = data;
                });
                

            },
            formatearEditar(x) {
                return x.reporte ? `<button type="button" data-action="0" data-params="${x}" class=" dt-formatterAction v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"><span class="v-btn__content"><span style="color: white;">Observacion</span></span></button>` : ``;

            },
            async Guardar() {
                let formdata = new FormData();
                formdata.append("bitacora", JSON.stringify(this.seleccion));
                this.$swal({
                    position: "center",
                    title: "Procesando la Solicitud ...",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirm: false,
                });
                this.$swal.showLoading();
                await UtilidadesServ.BitacoraEnvio(formdata).then(data => {
                    let tabla = "";
                    let msg = "";
                    let inf = "";
                    let width = "";
                    if (data.length == 0)
                    {
                        
                        this.$swal({
                            position: "center",
                            title: "Atención",
                            text: "Se guardó la información correctamente",
                            icon: "success",
                            width: width,// --'60em',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirm: false,
                        });
                    }
                    else if (data == false) {
                        
                        this.$swal({
                            position: "center",
                            title: "Atención",
                            text: "Ocurrió un error al procesar los datos",
                            icon: "error",
                            width: width,// --'60em',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirm: false,
                        });
                    }
                    else {
                        let tabla = '';
                        if (data.length == 0) {
                            tabla = "Actualización realizada correctamente"
                            inf = 'info';
                            width = "32em";
                        }
                        else {
                            width = '45em'
                            tabla = "<div style='text-align: center;'><table style='margin: 0 auto;'>";
                            for (var i = 0; i < data.length; i++) {
                                tabla += "<tr>";
                                tabla += "<td style='padding:  8px 8px; width: 130px;'>" + data[i].nrreporte + "-" + data[i].svindice + "</td>";
                                tabla += "<td style='padding:  8px 8px; text-align: justify'>" + data[i].error + "</td>";
                                if (data[i].documento != null)
                                    tabla += "<td style='padding:  8px 8px;'>" + data[i].documento + "</td>";
                                else
                                    tabla += "<td style='padding:  8px 8px;'>Expedientes</td>";
                                tabla += "</tr>";
                            }
                            tabla += "</table></div>"
                            inf = 'info';
                            width = "50%";
                        }

                        this.$swal({
                            position: "center",
                            title: "Atención",
                            html: tabla,
                            icon: inf,
                            width: width,// --'60em',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirm: false,
                        });
                    }
                });
                this.loadingB = true;
                this.seleccion = [];
                this.reloadTable();
            
            },
            SeleccionarTodo(tipo) {
                if (tipo == 1) {
                    const rows = this.apiDT.rows({ page: 'current' });
                    rows.select();
                    if (this.permisoCausion == false) {
                        this.apiDT.rows('.blocked-row').deselect();
                    }
                } else if (tipo == 2) {
                    const rows = this.apiDT.rows({ page: 'current' });
                    rows.deselect();
                } else if (tipo == 3) {
                    const rows = this.apiDT.rows({ page: 'current' });
                    rows.every(function () {
                        if (this.nodes().to$().hasClass('selected')) {
                            this.deselect();
                        } else {
                            this.select();
                        }
                    });
                    this.apiDT.rows('.blocked-row').deselect();
                }
            },
            seleccionarReportes(reporte) {
                this.seleccion = reporte;
            },
            reloadTable() {
                if (this.apiDT != null) {
                    this.apiDT.ajax.reload(null, false);
                    this.apiDT.columns.adjust().responsive.recalc();
                }
            },
        },
        async mounted() {
            this.showcargando = false;
            //this.displayInputs = {
            //    clclave: this.clclave,
            //};
            this.ver = true;
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '325').then(response => {

                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        },
        computed: {
            ...mapState({ drawer: (state) => state.drawer }),
            ...mapState(["domain", "informationPage"]),
            DRAWER_STATE: {
                get() {
                    return this.drawer;
                },
            },
        },
    }
</script>
<style scoped>
    .swal2-popup {
        width: 500% !important; /* Establece el ancho deseado */
    }

</style>
<style>
    .tablaEspecial div.dt-buttons {
        float: right;
    }
    .tablaEspecial div.dataTables_wrapper div.dataTables_filter {
        text-align: left;
    }
    .tablaEspecial .dataTables_wrapper .dataTables_filter {
        float: left;
        text-align: left;
    }
</style>